import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePreviewProComponent } from './profile-preview-pro.component';
import { RouterModule } from '@angular/router';
import { ImgResizeModule } from '../../img-resize/img-resize.module';
import { KzBadgeModule } from '../../../../kz-ui/ui/badge/kz-badge.module';
import { KzTagModule } from '../../../../kz-ui/ui/tag/kz-tag.module';
import { KzTooltipModule } from '../../../../kz-ui/ui/tooltip/kz-tooltip.module';
import { ContentPlaceholderModule } from '../../../../kz-ui/ui/content-placehoder/content-placeholder.module';
import { UtilsModule } from '../../../../utils/utils.module';
import { KzIconsModule } from '../../../../kz-ui/ui/icon/kz-icons.module';
import { ProServiceApiModule } from '@adeo/ngx-kozikaza-api/pro/service';

@NgModule({
  declarations: [
    ProfilePreviewProComponent
  ],
  exports: [
    ProfilePreviewProComponent
  ],
  imports: [
    ProServiceApiModule,
    CommonModule,
    ImgResizeModule,
    KzBadgeModule,
    KzTagModule,
    KzTooltipModule,
    RouterModule,
    ContentPlaceholderModule,
    UtilsModule,
    KzIconsModule,
  ]
})
export class ProfilePreviewProModule { }
